module.exports = __webpack_public_path__ + "img/cloth_g1_pants_09.7754ca40.svg";